import type { ConfigSection, GameProfile, ProfileCtx } from "./types";
import defaultProfile from "@/game_profiles/default";

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "ConfSection", props: { name: "custom_game_mode_settings" } },
  { component: "TableSection", props: { name: "owner_whitelist" } },
  { component: "ConfSection", props: { name: "sonsOfTheForestMods" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  configSections,
  statusPageConfig: {
    ...defaultProfile(_ctx).statusPageConfig,
    showRconPort: false,
  },
});
